module.exports = __webpack_public_path__ + "img/logo.9937d7b3.svg";